import { concatUrl } from '..';
import { NavigationElement, Node } from '../../models';

export const buildCurrentNavigationTree = (node: Node, parentNavigationTree?: NavigationElement): NavigationElement => {
    const path = node.pathId ? node.pathId : node.path;
    return {
        name: node.name && !node.isModuleEntry ? node.name : undefined,
        path: concatUrl([
            parentNavigationTree && parentNavigationTree.path ? parentNavigationTree.path : '/',
            path || '',
        ]),
        parent: parentNavigationTree,
        isModule: node.isModuleEntry || node.isSubModuleEntry,
        bannerId: node.bannerId,
    };
};
